/**
 * Central session-expiry event bus with deduping
 * Used to coordinate logout across components when 401 is received
 */

const SESSION_EXPIRY_EVENT = 'session-expiry';
let lastFiredAt = 0;
const DEBOUNCE_MS = 2000; // Prevent multiple rapid-fire events

/**
 * Fire a session-expiry event (deduplicated)
 * @param {string} source - Where the 401 originated (for debugging)
 */
export function fireSessionExpiry(source = 'unknown') {
  const now = Date.now();
  if (now - lastFiredAt < DEBOUNCE_MS) {
    console.debug(`[authEvents] session-expiry suppressed (debounce), source: ${source}`);
    return;
  }
  lastFiredAt = now;
  console.debug(`[authEvents] firing session-expiry, source: ${source}`);
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRY_EVENT, { detail: { source } }));
}

/**
 * Listen for session-expiry events
 * @param {function} callback - Called when session expires
 * @returns {function} Cleanup function to remove listener
 */
export function onSessionExpiry(callback) {
  const handler = (event) => callback(event.detail);
  window.addEventListener(SESSION_EXPIRY_EVENT, handler);
  return () => window.removeEventListener(SESSION_EXPIRY_EVENT, handler);
}
